<template>
    <div ref="beltInfo">
        <div ref="info">
            <el-collapse v-model="activeNames">
                <el-collapse-item name="1">
                    <template #title>
                        <div style="width: 100%; text-align: center; font-size: 18px; color: red; font-weight: bold;">
                            设备信息
                        </div>
                    </template>
                    <!-- 串号字体稍微加粗加大点；未绑定用户红色，绑定用户绿色；通信状态离线红色，不离线绿色；故障码正常绿色，有故障红色 -->
                    <el-descriptions title="" :column="3" style="margin-bottom: 20px; font-size: 16px;">
                        <el-descriptions-item label="设备ID">{{ beltData.did }}<el-button size="mini" type="danger" style="margin-left: 6px;" v-if="beltData.uid && beltData.uid.toString().indexOf('设备尚未绑定用户') == -1 && !$store.state.user.authAcc.includes(username)" @click="unbindEvt(beltData.serial_code)">解绑</el-button></el-descriptions-item>
                        <el-descriptions-item label="主人ID"><span class="green" :class="{warn: beltData.uid && beltData.uid.toString().indexOf('设备尚未绑定用户') != -1}">{{ beltData.uid }}</span></el-descriptions-item>
                        <el-descriptions-item label="主人手机">{{ beltData.user_phone }}</el-descriptions-item>
                        <el-descriptions-item label="串号"><span style="font-size: 20px;"><strong>{{ beltData.serial_code }}</strong></span></el-descriptions-item>
                        <el-descriptions-item label="通信状态"><span class="green" :class="{warn:connection_state.connection_state_name !== '在线'}">{{ connection_state.connection_state_name }}</span></el-descriptions-item>
                        <el-descriptions-item label="定位时间"><span :class="{warn: longTimePos(Date.now(),beltData.location_time) && !$store.state.user.authAcc.includes(username)}">{{ beltData.location_time }}</span></el-descriptions-item>
                        <el-descriptions-item label="故障码"><span class="green" :class="{warn:beltData.error_code !== '0'}">{{ errorCodeTypeToString(beltData.error_code) }}</span></el-descriptions-item>
                        <el-descriptions-item label="通信时间"><span :class="{warn: longTimePos(Date.now(),connection_state.comm_timestamp)} && !$store.state.user.authAcc.includes(username)">{{connection_state.comm_timestamp}}</span></el-descriptions-item>
                        <el-descriptions-item label="定位方式">{{ locTypeToString(beltData.loc_type) }}</el-descriptions-item>
                        <el-descriptions-item label="电量">{{ beltData.battery }}</el-descriptions-item>
                        <el-descriptions-item label="纬度">{{ beltData.latitude }}</el-descriptions-item>
                        <el-descriptions-item label="经度">{{ beltData.longitude }}</el-descriptions-item>
                        <el-descriptions-item label="硬件版本">{{ beltData.hardware_version }}</el-descriptions-item>
                        <el-descriptions-item label="固件版本"><span class="green" :class="{warn:beltData.firmware_version !== '58'}">{{ beltData.firmware_version }}</span></el-descriptions-item>
                        <el-descriptions-item label="4G固件版本">{{ beltData.firmware_4g_version }}</el-descriptions-item>
                        <el-descriptions-item label="工作模式">{{ workModeTypeToString(beltData.work_mode) }}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ beltData.register_time }}</el-descriptions-item>
                        <el-descriptions-item label="绑定时间">{{ beltData.binding_time }}</el-descriptions-item>
                        <el-descriptions-item label="宠物昵称">{{ petData.nickname }}</el-descriptions-item>
                        <el-descriptions-item label="宠物品种">{{ petData.breed_name }}</el-descriptions-item>
                        <el-descriptions-item label="宠物体重">{{ petData.weight != null ? (petData.weight + '千克') : '未知' }}</el-descriptions-item>
                        <el-descriptions-item label="宠物体型">{{ petData.weight != null ? (petData.weight_level_description) : '未知' }}</el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <template v-if="!$store.state.user.authAcc.includes(username)">
                    <el-collapse-item name="2">
                        <template #title>
                            <div style="width: 100%; text-align: center; font-size: 18px; color: red; font-weight: bold;">
                                星历文件
                            </div>
                        </template>
                        <el-table :data="ephemeris.v1_files" border style="width: 100%; padding-bottom: 20px;">
                            <el-table-column prop="filename" label="文件名" width="180"></el-table-column>
                            <el-table-column prop="size" label="文件大小" width="120"></el-table-column>
                            <el-table-column prop="mtime" label="文件时间" width="180"></el-table-column>
                        </el-table>

                        <el-table :data="ephemeris.v2_files" border style="width: 100%; padding-bottom: 20px;">
                            <el-table-column prop="filename" label="文件名" width="180"></el-table-column>
                            <el-table-column prop="size" label="文件大小" width="120"></el-table-column>
                            <el-table-column prop="mtime" label="文件时间" width="180"></el-table-column>
                        </el-table>
                    </el-collapse-item>
                    <el-collapse-item name="3">
                        <template #title>
                            <div style="width: 100%; text-align: center; font-size: 18px; color: red; font-weight: bold;">
                                SIM卡信息
                            </div>
                        </template>
                        <el-descriptions :column="3" style="margin-bottom: 20px; font-size: 16px;">
                            <el-descriptions-item label="卡号ICCID">{{ SIMCardData.iccid }}</el-descriptions-item>
                            <el-descriptions-item label="运营商">{{ SIMCardData.carrier }}</el-descriptions-item>
                            <el-descriptions-item label="出库日期">{{ SIMCardData.outbound_date }}</el-descriptions-item>

                            <el-descriptions-item label="卡状态">{{ SIMCardData.account_status }}</el-descriptions-item>
                            <el-descriptions-item label="已激活">{{ SIMCardData.active ? '是' : '否' }}</el-descriptions-item>
                            <el-descriptions-item label="激活日期">{{ SIMCardData.active_date }}</el-descriptions-item>

                            <el-descriptions-item label="数据余额">{{ SIMCardData.data_balance }} MB</el-descriptions-item>
                            <el-descriptions-item label="数据套餐">{{ SIMCardData.data_plan }} MB</el-descriptions-item>
                            <el-descriptions-item label="计费开始日期">{{ SIMCardData.start_date }}</el-descriptions-item>

                            <el-descriptions-item label="数据使用量">{{ SIMCardData.data_usage }} MB</el-descriptions-item>
                            <el-descriptions-item label="MSISDN">{{ SIMCardData.msisdn }}</el-descriptions-item>
                            <el-descriptions-item label="到期日期">
                                <span style="font-weight: bold; color: red;">
                                    {{ SIMCardData.expiry_date }}
                                </span>
                            </el-descriptions-item>

                            <el-descriptions-item label="IMSI">{{ SIMCardData.imsi }}</el-descriptions-item>
                            <el-descriptions-item label="短信端口">{{ SIMCardData.sp_code }}</el-descriptions-item>
                            <el-descriptions-item label="沉默期起始日期">{{ SIMCardData.silent_valid_date }}</el-descriptions-item>

                            <el-descriptions-item label="是否支持短信">{{ SIMCardData.support_sms ? '是' : '否' }}</el-descriptions-item>
                            <el-descriptions-item label="测试期已用流量">{{ SIMCardData.test_used_data_usage }} MB</el-descriptions-item>
                            <el-descriptions-item label="测试期起始日期">{{ SIMCardData.test_valid_date }}</el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>
                </template>
            </el-collapse>
            <div style="padding-top: 20px" v-if="!$store.state.user.authAcc.includes(username)">
                <div style="margin-bottom: 20px;display: flex;align-items: center;">
                    <el-date-picker :picker-options="pickerOptions" :clearable="false" v-model="history_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="handleHistoryDate"></el-date-picker>
                    <p style="margin-left: 10px;color:#999da6;">注：4G信号最大值31</p>
                </div>
                <el-descriptions :column="3" v-if="dotPos">
                    <template slot="title">
                        <div class="loc_type">
                            <span>{{`当前选点(${pIndex})信息`}}</span>
                            <el-tooltip class="item" effect="dark" placement="top" v-for="(item,index) in locTypes" :key="index" :disabled="trackArr(item.value).length === 0">
                                <template slot="content">
                                    <p v-for="(item,idx) in trackArr(item.value)" :key="idx">{{ item }}</p>
                                </template>
                                <el-tag effect="plain" :type="lIndex === item.value ? '':'info'" :class="{black: lIndex !== item.value}" @click="handleLocTypes(item.value)">{{item.name}}:{{trackNum(item.value)}}</el-tag>
                            </el-tooltip>
                        </div>
                    </template>
                    <el-descriptions-item label="定位时间">{{ dotPos.time }}</el-descriptions-item>
                    <el-descriptions-item label="纬度">{{ dotPos.latitude }}</el-descriptions-item>
                    <el-descriptions-item label="经度">{{ dotPos.longitude }}</el-descriptions-item>
                    <el-descriptions-item label="定位方式">{{ locTypeToString(dotPos.loc_type) }}</el-descriptions-item>
                    <el-descriptions-item label="WiFi定位精度" v-if="dotPos.loc_type === 1 || dotPos.loc_type === 4">{{ dotPos.accuracy }}</el-descriptions-item>
                    <el-descriptions-item label="GPS信号强度" v-if="dotPos.loc_type === 2">{{ gpsFilter(beltData.hardware_version, dotPos.HDOP,dotPos.DB_HZ) }}<span style="margin-left: 4px;color: gray;">(HDOP:{{dotPos.HDOP || '--'}},DB_HZ:{{dotPos.DB_HZ || '--'}})</span>
                        <el-tooltip class="item" effect="dark" placement="top">
                            <div slot="content">
                                if (HW >= 36 && HDOP >= 12 && DB_HZ
                                <= 26)<br />
                                &nbsp; &nbsp; &nbsp; &nbsp; return '弱'<br />
                                if (HW >= 36 && HDOP >= 25)<br />
                                &nbsp; &nbsp; &nbsp; &nbsp; return '弱'<br />
                                if (HW < 36 && HDOP> 75)<br />
                                    &nbsp; &nbsp; &nbsp; &nbsp; return '弱'<br />
                                    return '强'
                            </div>
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </el-descriptions-item>
                    <!-- [千卡路里，运动时间，当天的累计步数，每小时步数, 电池电量] -->
                    <el-descriptions-item label="基站信息" v-if="dotPos.loc_type === 3">{{ dotPos.cells_info }}</el-descriptions-item>
                    <el-descriptions-item labelStyle="display: none;"></el-descriptions-item>
                    <el-descriptions-item label="WiFi列表" v-if="dotPos.loc_type === 1 || dotPos.loc_type === 4">
                        <ellipsis-text :text="(dotPos.wifi_list||'').toString()" />
                    </el-descriptions-item>
                    <el-descriptions-item label="SSID列表" v-if="dotPos.loc_type === 1 || dotPos.loc_type === 4">
                        <ellipsis-text :text="(dotPos.wifi_ssid_list||'').toString()" />
                    </el-descriptions-item>
                </el-descriptions>
                <time-data :history_date="history_date" v-if="history_date"></time-data>
            </div>
        </div>
        <div class="mapbox">
            <div id="container" :style="{width:'100%', minHeight:'500px',height: `${map_height}px`}"> </div>
            <div class="btns">
                <el-button class="btn" size="small" @click="prevEvt" :disabled="pIndex === 0">上一点</el-button>
                <el-button class="btn" size="small" @click="nextEvt" :disabled="pIndex === history_track.length - 1 || history_track.length === 0">下一点</el-button>
                <el-button class="btn" size="small" @click="mapPolylineEvt" :disabled="history_track.length === 0">{{mapPolyline ? '隐藏': '显示'}}轨迹</el-button>
                <el-button class="btn" size="small" @click="rangingEvt" :disabled="history_track.length === 0" v-if="!$store.state.user.authAcc.includes(username)">测距</el-button>
                <el-button class="btn" size="small" @click="tileLayerEvt" :disabled="history_track.length === 0" v-if="!$store.state.user.authAcc.includes(username)">{{this.useSatellite ? '平面图层' : '卫星图层'}}</el-button>
            </div>
        </div>
        <div style="padding-top: 20px" v-if="$store.state.user.authAcc.includes(username)">
            <div style="margin-bottom: 20px;display: flex;align-items: center;">
                <el-date-picker :picker-options="pickerOptions" :clearable="false" v-model="history_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="handleHistoryDate"></el-date-picker>
                <p style="margin-left: 10px;color:#999da6;">注：4G信号最大值31</p>
            </div>
            <el-descriptions :title="`当前选点(${pIndex})信息`" :column="3" v-if="dotPos">
                <el-descriptions-item label="定位时间">{{ dotPos.time }}</el-descriptions-item>
                <el-descriptions-item label="纬度">{{ dotPos.latitude }}</el-descriptions-item>
                <el-descriptions-item label="经度">{{ dotPos.longitude }}</el-descriptions-item>
                <el-descriptions-item label="定位方式">{{ locTypeToString(dotPos.loc_type) }}</el-descriptions-item>
                <el-descriptions-item label="WiFi定位精度" v-if="dotPos.loc_type === 1 || dotPos.loc_type === 4">{{ dotPos.accuracy }}</el-descriptions-item>
                <el-descriptions-item label="GPS信号强度" v-if="dotPos.loc_type === 2">{{ gpsFilter(beltData.hardware_version, dotPos.HDOP,dotPos.DB_HZ) }}<span style="margin-left: 4px;color: gray;">(HDOP:{{dotPos.HDOP || '--'}},DB_HZ:{{dotPos.DB_HZ || '--'}})</span>
                    <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content">
                            if (HW >= 36 && HDOP >= 12 && DB_HZ
                            <= 26)<br />
                            &nbsp; &nbsp; &nbsp; &nbsp; return '弱'<br />
                            if (HW >= 36 && HDOP >= 25)<br />
                            &nbsp; &nbsp; &nbsp; &nbsp; return '弱'<br />
                            if (HW < 36 && HDOP> 75)<br />
                                &nbsp; &nbsp; &nbsp; &nbsp; return '弱'<br />
                                return '强'
                        </div>
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </el-descriptions-item>
                <!-- [千卡路里，运动时间，当天的累计步数，每小时步数, 电池电量] -->
                <el-descriptions-item label="基站信息" v-if="dotPos.loc_type === 3">{{ dotPos.cells_info }}</el-descriptions-item>
                <el-descriptions-item labelStyle="display: none;"></el-descriptions-item>
                <el-descriptions-item label="WiFi列表" v-if="dotPos.loc_type === 1 || dotPos.loc_type === 4">
                    <ellipsis-text :text="(dotPos.wifi_list||'').toString()" />
                </el-descriptions-item>
                <el-descriptions-item label="SSID列表" v-if="dotPos.loc_type === 1 || dotPos.loc_type === 4">
                    <ellipsis-text :text="(dotPos.wifi_ssid_list||'').toString()" />
                </el-descriptions-item>
            </el-descriptions>
            <time-data :history_date="history_date" v-if="history_date"></time-data>
        </div>
        <el-collapse v-model="activeNames" v-if="$store.state.user.authAcc.includes(username)">
            <el-collapse-item name="2">
                <template #title>
                    <div style="width: 100%; text-align: center; font-size: 18px; color: red; font-weight: bold;">
                        星历文件
                    </div>
                </template>
                <el-table :data="ephemeris.v1_files" border style="width: 100%; padding-bottom: 20px;">
                    <el-table-column prop="filename" label="文件名" width="180"></el-table-column>
                    <el-table-column prop="size" label="文件大小" width="120"></el-table-column>
                    <el-table-column prop="mtime" label="文件时间" width="180"></el-table-column>
                </el-table>

                <el-table :data="ephemeris.v2_files" border style="width: 100%; padding-bottom: 20px;">
                    <el-table-column prop="filename" label="文件名" width="180"></el-table-column>
                    <el-table-column prop="size" label="文件大小" width="120"></el-table-column>
                    <el-table-column prop="mtime" label="文件时间" width="180"></el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item name="3">
                <template #title>
                    <div style="width: 100%; text-align: center; font-size: 18px; color: red; font-weight: bold;">
                        SIM卡信息
                    </div>
                </template>
                <el-descriptions :column="3" style="margin-bottom: 20px; font-size: 16px;">
                    <el-descriptions-item label="卡号ICCID">{{ SIMCardData.iccid }}</el-descriptions-item>
                    <el-descriptions-item label="运营商">{{ SIMCardData.carrier }}</el-descriptions-item>
                    <el-descriptions-item label="出库日期">{{ SIMCardData.outbound_date }}</el-descriptions-item>

                    <el-descriptions-item label="卡状态">{{ SIMCardData.account_status }}</el-descriptions-item>
                    <el-descriptions-item label="已激活">{{ SIMCardData.active ? '是' : '否' }}</el-descriptions-item>
                    <el-descriptions-item label="激活日期">{{ SIMCardData.active_date }}</el-descriptions-item>

                    <el-descriptions-item label="数据余额">{{ SIMCardData.data_balance }} MB</el-descriptions-item>
                    <el-descriptions-item label="数据套餐">{{ SIMCardData.data_plan }} MB</el-descriptions-item>
                    <el-descriptions-item label="计费开始日期">{{ SIMCardData.start_date }}</el-descriptions-item>

                    <el-descriptions-item label="数据使用量">{{ SIMCardData.data_usage }} MB</el-descriptions-item>
                    <el-descriptions-item label="MSISDN">{{ SIMCardData.msisdn }}</el-descriptions-item>
                    <el-descriptions-item label="到期日期">
                        <span style="font-weight: bold; color: red;">
                            {{ SIMCardData.expiry_date }}
                        </span>
                    </el-descriptions-item>

                    <el-descriptions-item label="IMSI">{{ SIMCardData.imsi }}</el-descriptions-item>
                    <el-descriptions-item label="短信端口">{{ SIMCardData.sp_code }}</el-descriptions-item>
                    <el-descriptions-item label="沉默期起始日期">{{ SIMCardData.silent_valid_date }}</el-descriptions-item>

                    <el-descriptions-item label="是否支持短信">{{ SIMCardData.support_sms ? '是' : '否' }}</el-descriptions-item>
                    <el-descriptions-item label="测试期已用流量">{{ SIMCardData.test_used_data_usage }} MB</el-descriptions-item>
                    <el-descriptions-item label="测试期起始日期">{{ SIMCardData.test_valid_date }}</el-descriptions-item>
                </el-descriptions>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    import { debounce } from 'lodash'
    import { lazyAMapApiLoaderInstance } from 'vue-amap'
    import { formatDate, getBeltInfo, getPetInfoByDevice, getSignal4G, getEphemerisMeta, getSimCardInfo, getHistoryTrack, getHistoryMotion, getDeviceConnectState } from '../api'
    import EllipsisText from '@/components/EllipsisText';
    import TimeData from '@/components/TimeData';
    import { getCookiesToken } from '../api';
    import { timeCalculate } from '@/utils/tool';
    export default {
        components: {
            EllipsisText,
            TimeData
        },
        data () {
            let _this = this
            return {
                historyObj: {},
                pickerOptions: {
                    cellClassName (date) {
                        const formatObj = {
                            y: date.getFullYear(),
                            m: date.getMonth() + 1,
                            d: date.getDate(),
                            h: date.getHours(),
                            i: date.getMinutes(),
                            s: date.getSeconds(),
                            a: date.getDay()
                        }
                        const nyr = `${formatObj.y}-${formatObj.m.toString().padStart(2, '0')}-${formatObj.d.toString().padStart(2, '0')}`
                        const qSC = _this.$route.query['sc'];
                        if (!_this.historyObj[`${qSC}`]) _this.historyObj[`${qSC}`] = {}
                        if (_this.historyObj[`${qSC}`][`${nyr}`] === undefined) {
                            getHistoryTrack(qSC, nyr).then((data) => {
                                _this.historyObj[`${qSC}`][`${nyr}`] = data.data.data.length ? 1 : 0
                                if (data.data.data.length) {
                                    document.getElementsByClassName(nyr)[0].classList.add('badge')
                                }
                            }).catch((err) => {

                            })
                        }

                        if (_this.historyObj[`${qSC}`][`${nyr}`]) {
                            return 'badge'
                        } else {
                            return nyr
                        }
                    }
                },
                lIndex: -1,
                locTypes: [
                    {
                        name: 'WiFi',
                        value: 1,
                        key: 'wifiNum'
                    },
                    {
                        name: 'GPS',
                        value: 2,
                        key: 'gpsNum'
                    },
                    {
                        name: '基站',
                        value: 3,
                        key: 'g4Num'
                    },
                    {
                        name: '居家WiFi',
                        value: 4,
                        key: 'homeNum'
                    },
                    {
                        name: '过滤点',
                        value: 5,
                        key: 'filterNum'
                    }
                ],
                activeNames: ['1'],
                mapPolyline: null,
                pIndex: 0,
                beltData: {},
                petData: {
                    nickname: null,
                    breed_name: null,
                    weight: null,
                    weight_level: null,
                    weight_level_description: null
                },
                SIMCardData: {
                    account_status: null,
                    active: false,
                    active_date: null,
                    carrier: null,
                    data_balance: null,
                    data_plan: null,
                    data_usage: null,
                    expiry_date: null,
                    iccid: null,
                    imsi: null,
                    msisdn: null,
                    outbound_date: null,
                    silent_valid_date: null,
                    sp_code: null,
                    start_date: null,
                    support_sms: 0,
                    test_used_data_usage: null,
                    test_valid_date: null,
                },
                ephemeris: {
                    v1_files: [],
                    v2_files: []
                },
                connection_state: {
                    connection_state_name: '未知',
                    comm_timestamp: '未知'
                },
                map: null,
                history_date: '',
                history_track: [],
                battery_text: '',
                map_width: window.innerWidth - 80,
                map_height: 500,
                resizeObserver: null,
                debouncedResize: null,
                useSatellite: true,
                satelliteLayer: null,
                roadNetLayer: null,
                nebulaLayer: null
            }
        },
        computed: {
            dotPos () {
                return this.history_track[this.pIndex]
            },
            username () {
                return this.$store.state.user.username;
            }
        },
        watch: {
            history_track: {
                handler (val) {
                    val.forEach((item, index) => {
                        if (index < val.length - 1) {
                            console.info(`${index + 1}  ${timeCalculate(val[index].time, val[index + 1].time)} ${val[index].time} ${val[index + 1].time}`)
                        }
                    })
                },
                deep: true
            }
        },
        created () {
            // 创建防抖处理函数
            this.debouncedResize = debounce(this.handleResize, 200);
        },
        async mounted () {
            const element = this.$refs.beltInfo
            this.resizeObserver = new ResizeObserver(entries => {
                const { width, height } = entries[0].contentRect;
                // 使用防抖函数
                this.debouncedResize(width, height);
            });
            this.resizeObserver.observe(element);
            // 使用 lazyAMapApiLoaderInstance 确保 AMap 已加载完成
            lazyAMapApiLoaderInstance.load().then(() => {
                this.pageInit()
            }).catch(e => {
                console.error('AMap 加载失败', e);
            })
        },
        beforeDestroy () {
            this.resizeObserver.disconnect()
        },
        methods: {
            unbindEvt (code) {
                this.$prompt('请联系后台管理员', '解绑验证', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^123456$/,
                    inputErrorMessage: '请联系后台管理员'
                }).then(async ({ value }) => {
                    const bodyData = new FormData();
                    bodyData.append("serial_code", code);

                    const resetResponse = await fetch(process.env.VUE_APP_API_BASE_URL + "/admin/reset_device", {
                        method: 'POST',
                        headers: { 'Authorization': getCookiesToken() },
                        body: bodyData
                    });

                    console.log('response', resetResponse);

                    const resetData = await resetResponse.json();
                    if (resetData.code === 200) {
                        this.$message.success('解绑成功')
                        location.reload()
                    } else {
                        console.error('Reset Device data failed!', resetData);
                        this.$message.error('解绑失败')
                    }
                }).catch(() => { });
            },
            trackNum (loc_type) {
                if (loc_type === 5) {
                    return this.history_track.filter((item) => item.filter_type === 0).length
                }
                return this.history_track.filter((item) => item.loc_type === loc_type).length
            },
            trackArr (loc_type) {
                let arr = []
                this.history_track.forEach((item, index) => {
                    if (loc_type === 5) {
                        if (item.filter_type === 0) {
                            arr.push(`${index}：${item.filter_reason}`)
                        }
                    } else {
                        if (item.loc_type === loc_type) {
                            arr.push(`${index}`)
                        }
                    }
                })
                return loc_type === 5 ? arr : arr.length ? [arr.join(', ')] : [];
            },
            handleLocTypes (value) {
                if (this.lIndex != value) {
                    this.lIndex = value
                } else {
                    this.lIndex = -1
                }
                this.drawTrajectoryOnMap()
            },
            longTimePos (motion, location, min = 60) {
                if (!motion || !location) return false
                const sT = Object.prototype.toString.call(motion) === '[object String]' ? new Date(motion.replace(/-/g, '/')).getTime() : motion
                const eT = new Date(location.replace(/-/g, '/')).getTime()
                return sT - eT > (min * 60 * 1000)
            },
            handleResize (width, height) {
                this.map_height = Math.max(500, document.getElementById('el-main').offsetHeight - this.$refs.info.offsetHeight - 40)
            },
            gpsFilter (HW = 0, HDOP = 0, DB_HZ = 0) {
                if (HW >= 36 && HDOP >= 12 && DB_HZ <= 26)
                    return '弱'
                if (HW >= 36 && HDOP >= 25)
                    return '弱'
                if (HW < 36 && HDOP > 75)
                    return '弱'
                return '强'
            },
            async pageInit () {
                this.getCurrentData();
                const qDid = this.$route.query['did'];
                const qSC = this.$route.query['sc'];
                console.log('belt did query:', qDid);

                // 创建地图
                this.map = this.createMap();

                this.tileLayerEvt()
                // 初始化默认位置（防止 draw 时为空）
                let lo = 116.39;
                let la = 39.9;

                try {
                    // 获取设备信息
                    const beltRes = await getBeltInfo(qDid);
                    this.beltData = beltRes.data.data;
                    console.log('BeltData:', this.beltData);

                    lo = this.beltData.longitude ?? 116.39;
                    la = this.beltData.latitude ?? 39.9;

                    // 地图标记
                    /*const marker = new AMap.Marker({
                        position: new AMap.LngLat(lo, la)
                    });
                    this.map.add(marker);*/
                } catch (err) {
                    console.error("获取设备信息失败", err);
                }

                try {
                    // 获取宠物信息
                    const petRes = await getPetInfoByDevice(qSC);
                    if (petRes.status === 200 && petRes.data.code === 200) {
                        this.petData = petRes.data.data;
                        console.log('宠物信息:', this.petData);
                    } else {
                        throw new Error("获取宠物信息失败，状态码：" + petRes.status);
                    }
                } catch (err) {
                    console.error("获取宠物信息失败", err);
                }

                try {
                    // 获取连接状态
                    const stateRes = await getDeviceConnectState(qSC);
                    if (stateRes.status === 200 && stateRes.data.code === 200) {
                        this.connection_state = stateRes.data.data;
                        console.log("连接状态：", this.connection_state);
                    } else {
                        throw new Error("获取连接状态失败，状态码：" + stateRes.status);
                    }
                } catch (err) {
                    console.error("连接状态获取失败:", err);
                    this.connection_state = { "connection_state_name": '未知', "comm_timestamp": '未知' };
                }

                try {
                    // 获取星历文件
                    const ephemerisRes = await getEphemerisMeta(qSC);
                    if (ephemerisRes.status === 200 && ephemerisRes.data.code === 200) {
                        this.ephemeris = ephemerisRes.data.data;
                        console.log('星历文件:', this.ephemeris);
                        // for test
                        // throw new Error("获取星历文件失败，状态码：" + ephemerisRes.status);
                    } else {
                        throw new Error("获取星历文件失败，状态码：" + ephemerisRes.status);
                    }
                } catch (err) {
                    console.error("星历文件获取失败:", err);
                    this.ephemeris = { v1_files: [], v2_files: [] };
                }

                try {
                    // 获取SIM卡信息
                    const simRes = await getSimCardInfo(qSC);
                    if (simRes.status === 200 && simRes.data.data) {
                        this.SIMCardData = simRes.data.data;
                        console.log('SIM卡信息:', this.SIMCardData);
                        // 转换时间戳为时间字符串
                        this.SIMCardData.active_date = formatDate(this.SIMCardData.active_date);
                        this.SIMCardData.expiry_date = formatDate(this.SIMCardData.expiry_date);
                        this.SIMCardData.outbound_date = formatDate(this.SIMCardData.outbound_date);
                        this.SIMCardData.test_valid_date = formatDate(this.SIMCardData.test_valid_date);
                        this.SIMCardData.start_date = formatDate(this.SIMCardData.start_date);
                        this.SIMCardData.silent_valid_date = formatDate(this.SIMCardData.silent_valid_date);



                        console.log('Active Date:', this.SIMCardData.active_date);
                        console.log('Expiry Date:', this.SIMCardData.expiry_date);
                    } else {
                        throw new Error('错误信息:' + simRes.data.msg);
                    }
                } catch (err) {
                    console.error("SIM卡信息获取失败:", err);
                    this.SIMCardData = { iccid: err };
                }

                this.handleHistoryDate(this.history_date)
            },
            mapRanging () {
                var m1 = new AMap.Marker({
                    map: this.map,
                    draggable: true,
                    position: new AMap.LngLat(this.history_track[0].longitude, this.history_track[0].latitude)
                });
                var m2 = new AMap.Marker({
                    map: this.map,
                    draggable: true,
                    position: new AMap.LngLat(this.history_track[this.history_track.length - 1].longitude, this.history_track[this.history_track.length - 1].latitude)
                });
                this.map.setFitView();

                var line = new AMap.Polyline({
                    strokeColor: '#80d8ff',
                    isOutline: true,
                    outlineColor: 'white'
                });
                line.setMap(this.map);
                var text = new AMap.Text({
                    text: '',
                    style: {
                        'background-color': '#29b6f6',
                        'border-color': '#e1f5fe',
                        'font-size': '12px'
                    }
                });
                text.setMap(this.map)
                function computeDis () {
                    var p1 = m1.getPosition();
                    var p2 = m2.getPosition();
                    var textPos = p1.divideBy(2).add(p2.divideBy(2));
                    var distance = Math.round(p1.distance(p2));
                    var path = [p1, p2];
                    line.setPath(path);
                    text.setText('两点相距' + distance + '米')
                    text.setPosition(textPos)
                }
                computeDis();
                m1.on('dragging', computeDis)
                m2.on('dragging', computeDis)
            },
            formatTooltip (val) {
                let _index = Math.floor(val * (this.history_track.length - 1) / 100)
                return this.history_track[_index] ? this.history_track[_index].time : '--'
            },
            prevEvt () {
                this.pIndex--
                if (this.pIndex < 0) {
                    this.pIndex = 0
                }
                this.drawTrajectoryOnMap()
            },
            nextEvt () {
                this.pIndex++
                if (this.pIndex > this.history_track.length - 1) {
                    this.pIndex = this.history_track.length - 1
                }
                this.drawTrajectoryOnMap()
            },
            rangingEvt () {
                this.mapRanging()
            },
            mapPolylineEvt () {
                if (this.mapPolyline) {
                    this.mapPolyline.setMap(null)
                    this.mapPolyline = null
                } else {
                    this.createPolyline()
                }
            },
            tileLayerEvt () {
                this.useSatellite = !this.useSatellite
                if (this.useSatellite) {
                    this.satelliteLayer.show();
                    this.roadNetLayer.show();
                    this.nebulaLayer.hide();
                } else {
                    this.satelliteLayer.hide();
                    this.roadNetLayer.hide();
                    this.nebulaLayer.show();
                }
            },
            getCurrentData () {
                let currentTime = new Date()
                let year = currentTime.getFullYear()
                let month = currentTime.getMonth()
                month = month + 1 < 10 ? '0' + (month + 1) : month + 1
                let day = currentTime.getDate()
                day = day < 10 ? '0' + day : day
                this.history_date = year + '-' + month + '-' + day
            },

            handleHistoryDate (val) {
                this.history_date = val
                var qSC = this.$route.query['sc']
                getHistoryTrack(qSC, val).then((data) => {
                    this.history_track = data.data.data
                    this.pIndex = this.history_track.length ? this.history_track.length - 1 : 0
                    this.drawTrajectoryOnMap(true)
                }).catch((err) => {
                    console.error("获取历史定位失败:", err);
                })
            },

            createMap () {
                this.satelliteLayer = new AMap.TileLayer.Satellite();       // 卫星图层
                this.roadNetLayer = new AMap.TileLayer.RoadNet();         // 路网+标签
                this.nebulaLayer = new AMap.NebulaLayer({ style: 'light' }); // 织女星风格底图，含标签
                return new AMap.Map("container", {
                    resizeEnable: false,
                    center: [116.3, 39.9],
                    zoom: 18,
                    showLabel: true,
                    layers: [this.satelliteLayer, this.roadNetLayer, this.nebulaLayer]
                });
            },

            drawMarkerOnMap (lo, la, idx) {
                //console.log('markerposition:', lo, la)
                if (typeof (lo) == "undefined")
                    lo = 116.39;
                if (typeof (la) == "undefined")
                    la = 39.9;
                /*
                var marker = new AMap.Marker({
                    position: new AMap.LngLat(lo, la)
                });
                this.map.add(marker);*/

                var text = new AMap.Text({
                    text: idx.toString(),
                    anchor: "center",
                    draggble: false,
                    cursor: "pointer",
                    angle: 0,
                    zIndex: this.pIndex === idx ? 10 : 1,
                    visible: this.lIndex == -1 || this.history_track[idx].loc_type === this.lIndex || (this.lIndex === 5 && this.history_track[idx].filter_type === 0) ? true : false,
                    style: {
                        "background-color": this.pIndex === idx ? (this.history_track[idx].filter_type === 0 ? 'green' : 'red') : (this.history_track[idx].filter_type === 0 ? 'gray' : 'white'),
                        "color": this.pIndex === idx ? 'white' : "#000",
                    },
                    position: [lo, la]
                })
                text.setMap(this.map)

                var that = this
                text.on("click", function (e) {
                    var idx = +e.target.dom.innerText
                    that.pIndex = idx
                    that.drawTrajectoryOnMap()
                })
            },
            locTypeToString (loc_type) {
                switch (loc_type) {
                    case 1:
                        return "WiFi";
                    case 2:
                        return "GPS";
                    case 3:
                        return "基站";
                    case 4:
                        return "居家WiFi";
                    default:
                        return "未知";
                }
            },
            workModeTypeToString (work_mode) {
                // work_mode = 0b11110001;
                var continuous_location = work_mode & 0b00000001
                var rgb_state = work_mode & 0b00010000
                var connection_state = work_mode & 0b00100000
                var buzzer_state = work_mode & 0b01000000
                var charging_state = work_mode & 0b10000000

                var typeString = [];
                if (continuous_location) {
                    typeString.push("连续定位");
                }
                if (rgb_state) {
                    typeString.push("灯开启");
                }
                if (connection_state) {
                    typeString.push("高频模式");
                }
                if (buzzer_state) {
                    typeString.push("响铃");
                }
                if (charging_state) {
                    typeString.push("充电中");
                }

                if (typeString.length == 0)
                    typeString = "标准模式"
                else
                    typeString = typeString.join("、")
                console.log('work mode string:', typeString);
                return typeString;
            },
            errorCodeTypeToString (error_code) {
                // error_code = (0x00000001 | 0x00000800)

                var ERR_IMU_INIT = error_code & 0x00000001;
                var ERR_GPS_INIT = error_code & 0x00000002;
                var ERR_4G_INIT = error_code & 0x00000004;
                var ERR_4G_TX = error_code & 0x00000008;
                var ERR_4G_RX = error_code & 0x00000010;
                var ERR_4G_LP = error_code & 0x00000020;
                var ERR_4G_FW_ERR = error_code & 0x00000040;
                var ERR_HW = error_code & 0x00000080;
                var ERR_BLE = error_code & 0x00000100;
                var ERR_WIFI = error_code & 0x00000200;
                var ERR_CHARGE_VIN = error_code & 0x00000400;
                var ERR_CHARGE_THEM = error_code & 0x00000800;
                var ERR_CHARGE_BAT = error_code & 0x00001000;
                var ERR_CHARGE_STMR = error_code & 0x00002000;

                var errTypeString = [];
                if (ERR_IMU_INIT) {
                    errTypeString.push("IMU初始化故障");
                }
                if (ERR_GPS_INIT) {
                    errTypeString.push("GPS初始化故障");
                }
                if (ERR_4G_INIT) {
                    errTypeString.push("4G初始化故障");
                }
                if (ERR_4G_TX) {
                    errTypeString.push("4G通讯发送异常");
                }
                if (ERR_4G_RX) {
                    errTypeString.push("4G通讯接收异常");
                }
                if (ERR_4G_LP) {
                    errTypeString.push("4G通讯进入标准模式异常");
                }
                if (ERR_4G_FW_ERR) {
                    errTypeString.push("CAT1固件异常");
                }
                if (ERR_HW) {
                    errTypeString.push("硬件版本异常");
                }
                if (ERR_BLE) {
                    errTypeString.push("蓝牙版本异常");
                }
                if (ERR_WIFI) {
                    errTypeString.push("WIFI异常");
                }
                if (ERR_CHARGE_VIN) {
                    errTypeString.push("输入电压过高");
                }
                if (ERR_CHARGE_THEM) {
                    errTypeString.push("热关机");
                }
                if (ERR_CHARGE_BAT) {
                    errTypeString.push("电池过压");
                }
                if (ERR_CHARGE_STMR) {
                    errTypeString.push("安全时间到达");
                }

                if (errTypeString.length == 0)
                    errTypeString = "正常"
                else
                    errTypeString = errTypeString.join("、");
                console.log("err type string: ", errTypeString);
                return errTypeString
            },
            drawTrajectoryOnMap (bl) {
                if (this.mapPolyline) {
                    this.mapPolyline.setMap(null)
                    this.mapPolyline = null
                }
                this.map.clearMap()
                var lo, la
                for (var idx = 0; idx < this.history_track.length; idx++) {
                    var pos = this.history_track[idx]
                    lo = pos.longitude;
                    la = pos.latitude;
                    this.drawMarkerOnMap(lo, la, idx)
                }
                if (window.innerWidth < 750) {
                    pos = this.history_track[this.pIndex]
                    lo = pos.longitude
                    la = pos.latitude
                    this.map.setCenter([lo, la])
                } else {
                    if (this.history_track.length > 0 && bl) {
                        this.map.setCenter([lo, la])
                    }
                }
            },
            createPolyline () {
                const path = this.history_track.map(item => {
                    return [item.longitude, item.latitude]
                })
                if (this.mapPolyline) this.mapPolyline.setMap(null)
                if (path.length > 1) {
                    this.mapPolyline = new AMap.Polyline({
                        path: path,            // 设置线覆盖物路径
                        showDir: true,
                        strokeColor: '#3366bb',   // 线颜色
                        strokeWeight: 4           // 线宽
                    })
                    this.map.add([this.mapPolyline])
                    this.map.setFitView()
                }

            }
        }
    }
</script>
<style lang="less" scoped>
    .mapbox {
        position: relative;
        width: 100%;
        height: 100%;
        .btns {
            position: absolute;
            left: 10px;
            top: 10px;
        }
    }
    .el-descriptions ::v-deep {
        .el-descriptions-item__content {
            padding-right: 20px;
            overflow: hidden;
        }
    }
    .green {
        color: green;
        font-weight: bold;
    }
    .warn {
        color: red;
    }
    .loc_type {
        .el-tag {
            margin: 0 5px;
            cursor: pointer;
            user-select: none;
        }
    }
</style>